// @vue/component
import _groupBy from 'lodash.groupby';
import CallbackListItem from './CallbackListItem';
import EmptyList from '@/components/Common/EmptyList';

export default {
  name: 'CallbackList',

  components: {
    CallbackListItem,
    EmptyList,
  },

  props: {
    callbackList: {
      type: Array,
      default: () => [],
    },
    projectName: {
      type: String,
      default: '',
    },
    agentList: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
    };
  },

  computed: {
    connectionEffectsList() {
      return _groupBy(this.connectionEffectsListForCallback, 'effect');
    },
    connectionEffectsListForCallback() {
      return this.$store.getters["connections/effects/list"].records.filter(
        (item) => item.is_for_callback
      );
    },
    agentsAbleToCall() {
      return this.$store.getters['user/agent/agentsBelongsToUserlist'].records.filter(el => el.massdial4call === true);
    },
  },

  async created() {
    await this.$store.dispatch('connections/effects/getEffectList');
  },

};
